import React from 'react';

const StepContainer = ({ children, activeStep }) => {
  return (
    <div className="w-full">
      {React.Children.map(children, (child, index) => (
        <div 
          className={`${activeStep === index ? 'block' : 'hidden'}`}
          key={index}
        >
          {child}
        </div>
      ))}
    </div>
  );
};

export { StepContainer };